import gql from 'graphql-tag'

export const AGENCY_QUERY = gql`
query {
  agency {
    data {
      attributes {
        Intro {
          Title
          Description
          Caption
        }
        Services {
          Title
          Description
          Caption
        }
        ServicesSections {
          Title
          Content
        }
        ThePeople {
          Title
          Description
          Caption
        }
        team_members {
          data {
            id
            attributes {
              firstName
              lastName
              slug
              position
              Image {
                data {
                  attributes {
                    url
                    alternativeText
                    formats
                  }
                }
              }
            }
          }
        }
        HireUs {
          Title
          Description
          Caption
        }
        Button {
          href
          label
          isExternal
        }
        seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
